import React from 'react';
import PropTypes from 'prop-types';

import Frame from './Frame';
import DivImage from './DivImage';
import { Placeholder } from '../Placeholder';
import { useWindowSize } from '../../../hooks';

export default function FauxImage({
    src,
    mobileSrc,
    className,
    altText,
    aspectRatio,
    style,
    isLoading,
    ...rest
}) {

    const { width } = useWindowSize();

    if (aspectRatio) {
        return (
            <Frame aspectRatio={aspectRatio} className={className} style={style}>
                {isLoading ? (
                    <Placeholder />
                ) : (
                    <DivImage src={src} altText={altText} {...rest} />
                )}
            </Frame>
        );
    } else if (isLoading) {
        return <Placeholder style={style} />;
    }

    return (
        <React.Fragment>
            {width <= 768 && mobileSrc ? (
                <DivImage
                    src={mobileSrc}
                    altText={altText}
                    style={style}
                    className={className}
                    {...rest}
                />
            ) : (
                <DivImage
                    src={src}
                    altText={altText}
                    style={style}
                    className={className}
                    {...rest}
                />
            )}
        </React.Fragment>
    );
}

FauxImage.propTypes = {
    /** If true, shows loading placeholder instead of image */
    isLoading: PropTypes.bool,

    /** The image URL */
    src: PropTypes.string,

    /** Optional mobile image URL - Add this to display an Image when the viewport is less than 768px */
    mobileSrc: PropTypes.string,

    /** Text to use as the accessible label */
    altText: PropTypes.string,

    /** If provided, the image will always conform to the aspect ratio (the
     * height will change based on the width). This value MUST be provided as
     * a string with a width followed by a colon followed by a height, such
     * as "16:9" */
    aspectRatio: PropTypes.string,

    /** Additional class added to the outer container. */
    className: PropTypes.string,

    /** Additional inline style options that will be added in to what the
     * component sets internally. Try not to use this */
    style: PropTypes.object,
};
